export class LookupConstants {
    static TEMPLATE_TYPES = ["Email", "Letter", "SMS"];
    static YES_NO = ["Yes", "No"];
    static INVOICE_TYPES = ["Invoice", "Quote", "Deposit"];
    // advertising module start
    static REMOVAL_PERIOD_LOOKUPS_A = [
        { code: "60 days", value: "60 days" },
        { code: "90 days", value: "90 days" }
    ];
    static NON_ILLUMINATED_BILLBOARD_A = [
        { code: "Double sided", value: "Double sided" },
        { code: "Single sided", value: "Single sided" }
    ];
    static INTERNALLY_ILLUMINATED_BILLBOARD_LOOKUPS_A = [
        { code: "Double Sided", value: "Double Sided" },
        { code: "Single sided", value: "Single sided" }
    ];
    static NON_ILLUMINATED_GANTRY_A = [
        { code: "Double sided", value: "Double sided" },
        { code: "Single sided", value: "Single sided" }
    ];
    static DIGITAL_GANTRY_A = [
        { code: "Double sided", value: "Double sided" },
        { code: "Single sided", value: "Single sided" }
    ];
    static APPLICATION_DURATION_LOOKUPS_A = [
        { code: "1 year application", value: "1 year application" },
        { code: "5 years application", value: "5 years application" }
    ];
    static PERMANENT_OR_TEMPORARY_LOOKUPS_A = [
        { code: "permanent", value: "permanent" },
        { code: "temporary", value: "temporary" }
    ];
    static AREA_OF_DISPLAY_LOOKUPS_A = [
        { code: "Ballito", value: "Ballito" },
        { code: "KwaDukuza", value: "KwaDukuza" },
        { code: "Salt rock /Umhlali", value: "Salt rock /Umhlali" },
        { code: "Shakaskraal", value: "Shakaskraal" },
    ];
}
